import * as React from "react"
import {Box} from "@mui/material"
import {useAppToast} from "@ui-seeker/app"
import {ButtonLoadingSeeker, IconSeeker} from "@ui-seeker/core"
import {postSubmit} from "@ui-seeker/utils"

import {BACKEND_APIS} from "@constants"
import {useUserApp} from "@hooks";
import {newProductsLoadingRow, newProductsMultipleRowsSend, newProductsMultipleRowsSkip, newProductsTableData} from "../@signals"

export default function SkipMultipleButton({onClick}) {

    const { showToast } = useAppToast()
    const { username } = useUserApp()

    const handleClick = () => {
        onClick()
        showToast.confirm(`Are you sure you want to skip the following selection`, {
            onSubmit: () => {
                newProductsLoadingRow.value = [...newProductsLoadingRow.value, ...newProductsMultipleRowsSkip.value.map((row => row.key))]
                postSubmit(`${BACKEND_APIS.UNMATCHED}/new-products/multiple-update-mapping`, {
                    productsData: newProductsMultipleRowsSkip.value,
                    skuID: 0,
                    skip: true,
                    validated: true,
                    qa: true,
                    username: username,
                }).then((res) => {
                    newProductsTableData.value = newProductsTableData.value.filter(row => !res.rowKeys.includes(row.key))
                    newProductsMultipleRowsSend.value = res.rowKeys
                    newProductsLoadingRow.value = [...newProductsLoadingRow.value.filter(key => !res.rowKeys.includes(key))]
                }).catch(() => console.log('ERROR EXTERNAL MAPPING SKU'))
            }
        })
    }

    return <Box component="span" sx={{mr: 1}}>
        <ButtonLoadingSeeker
            loading={false}
            label="Skip"
            startIcon={<IconSeeker icon={'forward'} />}
            onClick={handleClick}
        >
            Skip Multiple
        </ButtonLoadingSeeker>
    </Box>
}